/**
 * @license lucide v0.356.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const ContactRound = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M16 18a4 4 0 0 0-8 0" }],
    ["circle", { cx: "12", cy: "11", r: "3" }],
    ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2" }],
    ["line", { x1: "8", x2: "8", y1: "2", y2: "4" }],
    ["line", { x1: "16", x2: "16", y1: "2", y2: "4" }]
  ]
];

export { ContactRound as default };
//# sourceMappingURL=contact-round.js.map
